// extracted by mini-css-extract-plugin
export default {"container":"Offer_container__gS8Nr","navbar":"Offer_navbar__4MhSo","offers-list":"Offer_offers-list__sJh9M"};